
import { useMemo, useReducer } from "react";
import DossiersGrid from "./DossiersGrid";
import DossierPage from "./DossierPage";
import { AppState, Sections_dossier } from "shared/types/types";
import { Action, reducer } from "features/documents";
import CreateDossierDialog from "components/idlocker/CreateDossierDialog";

import "styles/idlocker.css"

const initialState: AppState = {
    dossiers:[], 
    ui:{
        route:"grid",
        showCreate:false
    }
};

function appReducer(state: AppState, action:Action){
    return reducer(state,action);
}

export default function IDLockerFlow(){
    const [state, dispatch] = useReducer(appReducer, initialState);
    const route = state.ui.route;
    const current = useMemo(()=> route === "grid" ? null : (state.dossiers.find(d => d.id === (route as any).dossierId) || null), [route, state.dossiers]);

    return(
        <div>
            {route === "grid" ? (
                <DossiersGrid dossiers={state.dossiers} onNew={() => dispatch({type:"OPEN_CREATE", open:true})} onOpen={(id) => dispatch({type:"OPEN_DOSSIER", id})}/>
            ) : current ? (
                <DossierPage 
                    dossier={current} 
                    routeLeft={(route as any).left as Sections_dossier} 
                    garantDetail={(route as any).garantDetail}
                    dispatch={dispatch} 
                    goBack={()=>dispatch({type:"GO_GRID"})}
                />
            ):null}
            <CreateDossierDialog open={state.ui.showCreate} onClose={()=>dispatch({type:"OPEN_CREATE", open:false})} onCreate={(t, name)=>dispatch({type:"CREATE_DOSSIER", payload:{type:t, name} })}/>
        </div>
    );
}
